import React, { useState, useContext, useCallback } from 'react';
import { Tabs, Page, Layout, Card } from '@shopify/polaris';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import { hasPermission } from '#client/utils/helpers';

import UserManagementTab from './UserManagementTab';
import RoleMatrixTab from './RoleMatrixTab';
import SettingsTab from './SettingsTab';
import './AdminSettings.css';
import ReasonCodeManage from './ReasonCodeManage';
import LabelPrinters from './LabelPrinters';

const AdminSettings = () => {
    const { currentUser } = useContext(SessionContext);

    const tabs = [
        ...(hasPermission(currentUser, 'settingPermissions')
            ? [
                  {
                      id: 'settings',
                      content: 'Settings',
                      panelID: 'settings-panel',
                  },
                  {
                      id: 'users',
                      content: 'Users',
                      panelID: 'users-panel',
                  },
                  {
                      id: 'permissions',
                      content: 'Roles & Permissions',
                      panelID: 'permissions-panel',
                  },
              ]
            : []),
        ...(hasPermission(currentUser, 'settingReasonCodes')
            ? [
                  {
                      id: 'reason-codes',
                      content: 'Reason Codes',
                      panelID: 'reason-codes-panel',
                  },
              ]
            : []),
        {
            id: 'label-printers',
            content: 'Label Printers',
            panelID: 'label-printers-panel',
        },
    ];

    const [selectedTabId, setSelectedTabId] = useState(() => {
        return tabs.length > 0 ? tabs[0].id : 'settings';
    });

    const handleTabChange = useCallback(
        (selectedTabIndex) => {
            const selected = tabs[selectedTabIndex];
            if (selected) {
                setSelectedTabId(selected.id);
            }
        },
        [tabs]
    );

    return (
        <Page title="Admin Settings">
            <Layout>
                <Layout.Section>
                    <Card padding="0">
                        <Tabs tabs={tabs} selected={tabs.findIndex((tab) => tab.id === selectedTabId)} onSelect={handleTabChange} fitted />
                        {selectedTabId === 'settings' && <SettingsTab />}
                        {selectedTabId === 'users' && <UserManagementTab />}
                        {selectedTabId === 'permissions' && <RoleMatrixTab />}
                        {selectedTabId === 'reason-codes' && <ReasonCodeManage />}
                        {selectedTabId === 'label-printers' && <LabelPrinters />}
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
};

export default AdminSettings;
